import React from "react";
import { RaffleParticipant } from "@/apps/raffle/types";
import { RaffleWheelProvider } from "./RaffleWheelContext";
import { WheelSurface } from "./WheelSurface";

interface RaffleWheelProps {
  participants: RaffleParticipant[];
  currentParticipantIndex?: number;
}

export const RaffleWheel = ({
  participants,
  currentParticipantIndex,
}: RaffleWheelProps) => {
  return (
    <RaffleWheelProvider
      participants={participants}
      currentParticipantIndex={currentParticipantIndex}
    >
      <WheelSurface />
    </RaffleWheelProvider>
  );
};
